export const PASS_CORS_KEY='temp_0df7424d80ea80376634c297fe437c9a'